import {friendlyDate} from '../../../tools/date-format'

export default {
    name: "EdDate",
    functional: true,
    props: {
        // date 日期对象/日期字符串/时间戳
        date: {
            type: [Object, String, Number],
        },
        // 格式化使用的语言
        locale: {
            type: String,
            default: 'zh',
        },
        // 应用不同类型格式化的阈值
        threshold: {
            type: Array,
            default() {
                return [0, 0]
            }
        },
        // 输出日期字符串时的格式
        format: {
            type: String,
            default: 'yyyy/MM/dd hh:mm:ss'
        },
    },
    render: (h, ctx) => {
        let dataShow = "-"
        if (ctx.props.date) {
            dataShow = ctx.props.date
        }

        if (ctx.children) {
            dataShow = ctx.children[0].text
        }

        let date = friendlyDate(dataShow, {
            locale: ctx.props.locale,
            threshold: ctx.props.threshold,
            format: ctx.props.format
        })
        return h('span', {
            domProps: {
                innerHTML: date // 这里是要渲染的数据
            }
        })
    }
}
